import React, { useEffect, useState } from 'react';
import ComanServices from '../../services/ComanServices';

function LandingPage() {
  const [pageData, setPageData] = useState({
    home: {
      title: '',
      subTitle: '',
      image: ''
    },
    about: {
      title: '',
      subTitle: '',
      description: '',
      image: ''
    },
    plan: {
      title: '',
      subTitle: ''
    },
    feature: {
      title: '',
      subTitle: ''
    }
  });

  const [file, setFile] = useState(null);

  // Fetch existing data
  useEffect(() => {
    ComanServices.getLandingPage().then(response => {
      setPageData(response?.data || pageData);
    }).catch(error => {
      console.log(error);
    });
  }, []);

  // Handle form input changes
  const handleInputChange = (section, field, value) => {
    setPageData(prevState => ({
      ...prevState,
      [section]: {
        ...prevState[section],
        [field]: value
      }
    }));
  };

  // Handle file input changes
  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  // Handle form submission to update data
  const handleSubmit = (e) => {
    e.preventDefault();

    // Create form data for file upload
    const formData = new FormData();
    formData.append('image', file);
    formData.append('pageData', JSON.stringify(pageData));

    // Send updated page data to the server
    ComanServices.updateLandingPage(formData).then(response => {
      console.log('Page updated successfully:', response);
    }).catch(error => {
      console.log('Error updating page:', error);
    });
  };

  return (
    <div className="right_col" role="main">
      <div className="title-box">
        <h2>Landing Page</h2>
      </div>

      {/* Hero Section */}
      <section>
        <div className="container-box px-5">
          <div className="container-box-inner">
            <div className="title-box mb-2">
              <h2>Hero Section</h2>
            </div>
            <div className="page-details">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-field">
                      <label>Title</label>
                      <input
                        type="text"
                        name="home-title"
                        className="form-control"
                        value={pageData.home.title}
                        onChange={(e) => handleInputChange('home', 'title', e.target.value)}
                        placeholder="Title"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-field">
                      <label>Sub-Title</label>
                      <input
                        type="text"
                        name="home-subTitle"
                        className="form-control"
                        value={pageData.home.subTitle}
                        onChange={(e) => handleInputChange('home', 'subTitle', e.target.value)}
                        placeholder="Sub Title"
                      />
                    </div>
                  </div>
                  <div className="col-md-12">
                    <div className="input-field">
                      <label>Image</label>
                      <input
                        type="file"
                        name="home-image"
                        className="form-control"
                        onChange={handleFileChange}
                      />
                    </div>
                  </div>
                </div>
                <button className="submit-green-btn" type="submit">SUBMIT</button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* About Us Section */}
      <section>
        <div className="container-box px-5">
          <div className="container-box-inner">
            <div className="title-box mb-2">
              <h2>About Us Section</h2>
            </div>
            <div className="page-details">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-field">
                      <label>Title</label>
                      <input
                        type="text"
                        name="about-title"
                        className="form-control"
                        value={pageData.about.title}
                        onChange={(e) => handleInputChange('about', 'title', e.target.value)}
                        placeholder="Title"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-field">
                      <label>Sub-Title</label>
                      <input
                        type="text"
                        name="about-subTitle"
                        className="form-control"
                        value={pageData.about.subTitle}
                        onChange={(e) => handleInputChange('about', 'subTitle', e.target.value)}
                        placeholder="Sub Title"
                      />
                    </div>
                  </div>
                 
                  
                </div>
                <button className="submit-green-btn" type="submit">SUBMIT</button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Plans Section */}
      <section>
        <div className="container-box px-5">
          <div className="container-box-inner">
            <div className="title-box mb-2">
              <h2>Plans Section</h2>
            </div>
            <div className="page-details">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-field">
                      <label>Title</label>
                      <input
                        type="text"
                        name="plan-title"
                        className="form-control"
                        value={pageData.plan.title}
                        onChange={(e) => handleInputChange('plan', 'title', e.target.value)}
                        placeholder="Title"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-field">
                      <label>Sub-Title</label>
                      <input
                        type="text"
                        name="plan-subTitle"
                        className="form-control"
                        value={pageData.plan.subTitle}
                        onChange={(e) => handleInputChange('plan', 'subTitle', e.target.value)}
                        placeholder="Sub Title"
                      />
                    </div>
                  </div>
                </div>
                <button className="submit-green-btn" type="submit">SUBMIT</button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section>
        <div className="container-box px-5">
          <div className="container-box-inner">
            <div className="title-box mb-2">
              <h2>Features List Section</h2>
            </div>
            <div className="page-details">
              <form onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-field">
                      <label>Title</label>
                      <input
                        type="text"
                        name="feature-title"
                        className="form-control"
                        value={pageData.feature.title}
                        onChange={(e) => handleInputChange('feature', 'title', e.target.value)}
                        placeholder="Title"
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-field">
                      <label>Sub-Title</label>
                      <input
                        type="text"
                        name="feature-subTitle"
                        className="form-control"
                        value={pageData.feature.subTitle}
                        onChange={(e) => handleInputChange('feature', 'subTitle', e.target.value)}
                        placeholder="Sub Title"
                      />
                    </div>
                  </div>
                </div>
                <button className="submit-green-btn" type="submit">SUBMIT</button>
              </form>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default LandingPage;
